import { createReducer, on } from "@ngrx/store";
import { findWithholdingCatalogAct, loadWithholdingCatalogByIdAct, resetWithholdingCatalogAct, saveSuccessWithholdingCatalogAct, setViolationsWithholdingCatalogAct, showMsgErrorAct, updateSuccessWithholdingCatalogAct } from "./withholding-catalog.action";
import { Withholding } from "../../models/withholding";

const withholding: Withholding = new Withholding();

export const WithholdingCatalogReducer = createReducer (
    {
        withholding,
        violations: {},
        loading: true 
    },
    on(resetWithholdingCatalogAct, (state) => ({
        withholding:  { ...withholding },
        violations: {},
        loading: state.loading
    })),
    on(findWithholdingCatalogAct, (state, { id }) =>({
        withholding: { ...withholding}, 
        violations: state.violations,
        loading: true
    })),
    on(loadWithholdingCatalogByIdAct, (state, { withholding }) =>({
        withholding: { ...withholding}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessWithholdingCatalogAct, (state, { withholdingNew }) => ({
        withholding: { ...withholdingNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessWithholdingCatalogAct, (state, { withholdingUpdated }) => ({
        withholding: { ...withholdingUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsWithholdingCatalogAct, (state, { withholdingForm, violations }) => ({
        withholding: { ...withholdingForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        withholding: state.withholding,
        violations: {},
        loading: false
    }))
)